var _a;
import { Partner_Card_Title } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Partner_Card_Title.BenefitsPortal] = 'Benefits Portal',
    _a[Partner_Card_Title.BenefitSupport] = 'Benefit Support',
    _a[Partner_Card_Title.CaregivingSupport] = 'Caregiving Support',
    _a[Partner_Card_Title.Carrier] = 'Carrier',
    _a[Partner_Card_Title.CaseManagement] = 'Case Management',
    _a[Partner_Card_Title.ChronicCondition] = 'Chronic Condition',
    _a[Partner_Card_Title.Commuter] = 'Commuter',
    _a[Partner_Card_Title.CriticalIllnessAccident] = 'Critical Illness/Accident',
    _a[Partner_Card_Title.Dental] = 'Dental',
    _a[Partner_Card_Title.Diabetes] = 'Diabetes',
    _a[Partner_Card_Title.DirectPrimaryCare] = 'Direct Primary Care',
    _a[Partner_Card_Title.Disability] = 'Disability',
    _a[Partner_Card_Title.DiscountPrograms] = 'Discount Programs',
    _a[Partner_Card_Title.Education] = 'Education',
    _a[Partner_Card_Title.EmployeeAssistanceProgram] = 'Employee Assistance Program',
    _a[Partner_Card_Title.FamilyPlanning] = 'Family Planning',
    _a[Partner_Card_Title.FemaleWellness] = 'Female Wellness',
    _a[Partner_Card_Title.Fertility] = 'Fertility',
    _a[Partner_Card_Title.Finances] = 'Finances',
    _a[Partner_Card_Title.Financial] = 'Financial',
    _a[Partner_Card_Title.Fitness] = 'Fitness',
    _a[Partner_Card_Title.FlexCommuter] = 'Flex/Commuter',
    _a[Partner_Card_Title.Flex] = 'Flex',
    _a[Partner_Card_Title.Fmla] = 'FMLA',
    _a[Partner_Card_Title.FourOOneKRetirement] = '401 (k) (Retirement)',
    _a[Partner_Card_Title.Fsa] = 'FSA',
    _a[Partner_Card_Title.GapInsurance] = 'GAP Insurance',
    _a[Partner_Card_Title.GriefCounseling] = 'Grief Counseling',
    _a[Partner_Card_Title.HealthManagement] = 'Health Management',
    _a[Partner_Card_Title.HomeAndAutoInsurance] = 'Home and Auto Insurance',
    _a[Partner_Card_Title.HormonalHealth] = 'Hormonal Health',
    _a[Partner_Card_Title.HospitalIndemnity] = 'Hospital Indemnity',
    _a[Partner_Card_Title.Hra] = 'HRA',
    _a[Partner_Card_Title.Hsa] = 'HSA',
    _a[Partner_Card_Title.HsaFsa] = 'HSA/FSA',
    _a[Partner_Card_Title.IdentityTheft] = 'Identity Theft',
    _a[Partner_Card_Title.InvestmentAdvice] = 'Investment Advice',
    _a[Partner_Card_Title.LegalServices] = 'Legal Services',
    _a[Partner_Card_Title.LifeInsurance] = 'Life Insurance',
    _a[Partner_Card_Title.LifeSupportServices] = 'Life Support Services',
    _a[Partner_Card_Title.LongTermCare] = 'Long-Term Care',
    _a[Partner_Card_Title.LongTermDisability] = 'Long-Term Disability',
    _a[Partner_Card_Title.Maternity] = 'Maternity',
    _a[Partner_Card_Title.Medical] = 'Medical',
    _a[Partner_Card_Title.MensWellness] = 'Men\'s Wellness',
    _a[Partner_Card_Title.MentalHealth] = 'Mental Health',
    _a[Partner_Card_Title.Musculoskeletal] = 'Musculoskeletal',
    _a[Partner_Card_Title.NewMotherWellness] = 'New Mother Wellness',
    _a[Partner_Card_Title.Nurseline] = 'Nurseline',
    _a[Partner_Card_Title.OptInForm] = 'Opt-In Form',
    _a[Partner_Card_Title.Other] = 'Other',
    _a[Partner_Card_Title.ParentalSupport] = 'Parental Support',
    _a[Partner_Card_Title.Payroll] = 'Payroll',
    _a[Partner_Card_Title.Pediatrics] = 'Pediatrics',
    _a[Partner_Card_Title.PetInsurance] = 'Pet Insurance',
    _a[Partner_Card_Title.Prescriptions] = 'Prescriptions',
    _a[Partner_Card_Title.PrimaryCare] = 'Primary Care',
    _a[Partner_Card_Title.Retirement] = 'Retirement',
    _a[Partner_Card_Title.SecondOpinion] = 'Second Opinion',
    _a[Partner_Card_Title.ShortTermDisability] = 'Short Term Disability',
    _a[Partner_Card_Title.SpecialtyPharmacy] = 'Specialty Pharmacy',
    _a[Partner_Card_Title.SpeechTherapy] = 'Speech Therapy',
    _a[Partner_Card_Title.Telemedicine] = 'Telemedicine',
    _a[Partner_Card_Title.TravelAssistance] = 'Travel Assistance',
    _a[Partner_Card_Title.TuitionAssistanceProgram] = 'Tuition Assistance Program',
    _a[Partner_Card_Title.VirtualPrimaryCare] = 'Virtual Primary Care',
    _a[Partner_Card_Title.VirtualSecondOpinion] = 'Virtual Second Opinion',
    _a[Partner_Card_Title.Vision] = 'Vision',
    _a[Partner_Card_Title.VoluntaryBenefits] = 'Voluntary Benefits',
    _a[Partner_Card_Title.WeightLoss] = 'Weight Loss',
    _a[Partner_Card_Title.Wellness] = 'Wellness',
    _a[Partner_Card_Title.WholeLifeInsurance] = 'Whole Life Insurance',
    _a[Partner_Card_Title.WillPrep] = 'Will Prep',
    _a);
export var PartnerCardTitleEnum = {
    name: 'Partner_Card_Title',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
